import { Component, EventEmitter, NgModule, OnInit, ViewEncapsulation } from '@angular/core';
import { RootLayout } from '../root/root.component';
import * as moment from 'moment';
import { NotificationModel } from 'src/app/@core/models/notification.model';
import { NotificationService } from 'src/app/@core/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'navigation-layout',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss'],
	encapsulation: ViewEncapsulation.None
})


export class NavigationLayout extends RootLayout implements OnInit {

	me = this.store.getItem('currentUser');
	isAccountant = this.authService.isAccountant() ? true: false;
	isAdmin = this.authService.isAdmin() ? true: false;
	permissions
	viewuser = false;
	viewticket = false;
	viewcustomer = false;
	mobile = false
	
	ngOnInit() {
		let _this = this;
		document.documentElement.style.setProperty('--primary-color', '#515d75');
		document.documentElement.style.setProperty('--secondary-color', '#1E475B');
		document.documentElement.style.setProperty('--tertiary-color', '#007be8');
		document.documentElement.style.setProperty('--sidebar-color', '#ffffff');

		this.permissions = this.me['permissions']
		//this.getPermission();
		//_this.getNotif();
		//this.filterMenu();
		if (!this.authService.didFirstCheck) {
			this.init();
			this.authService.didFirstCheck = true;
		}

		if (window.innerWidth > 768) { // 768px portrait
			console.log('mobile view')
			//this.mobile = false;
			//this.togg = false;
		  }

		this.subService.cardsUpdated.subscribe(res => {
			console.log(res);
		});
	}

	init() {
		let _this = this;
		this.changeLayout('menu-pin');
		let timeout = setInterval(() => {
			if (_this.authService.authenticated) {
				clearTimeout(timeout);
			}
			else {
				_this.authService.checkAuth();
			}
		}, 1000);
		// setTimeout(() => {
		//   _this.authService.checkAuth();
		// }, 500);
		if (!this.authService.triggered) {
			this.authService.triggered = true;
			this.authService.initialTimeout = setTimeout(() => {
				_this.authService.initialTimeout = null;
			}, 2000);
		}
	}

	// getPermission(){
	// 	for(let per of this.permissions){
	// 		console.log(per)
	// 		if(per == 'view_customer'){
	// 			this.viewcustomer = true;
	// 		}

	// 		if(per == 'list_user'){
	// 			this.viewuser = true;
	// 		}

	// 		if(per == 'view_support_ticket'){
	// 			this.viewticket = true;
	// 		}
	// 	}

	// }

	
	handleSocket(res) {
		console.log(res);
	}

	togg = true
	toggle(){
		
		this.togg = !this.togg;
		console.log(this.togg)
	}

	BodyClicked(){
		this.togg = true;
	}	

	getAvatar() {
		return "/assets/avatar.png";
	}

	// getNotifications() {
	// 	return this.notificationService.notifications;
	// }

	// loadNotifications(isLoadMore) {
	// 	this.notificationService.loadNotifications(isLoadMore);
	// }

	// readAll() {
	// 	this.notificationService.readAllNotifications();
	// }

	Profile(){
		this.router.navigate(['/profile']);
	}

	Settings(){
		this.router.navigate(['/settings']);
	}

	// markRead(notification: NotificationModel) {
	// 	if (notification.read_at) {
	// 		return;
	// 	}
	// 	notification.read_at = moment(new Date()).format();
	// 	if (this.notificationService.has_unread > 0) {
	// 		this.notificationService.has_unread--;
	// 	}
	// 	this.notificationService.markRead(notification);
	// }

	// activateNotification(notification) {
	// 	this.markRead(notification);
	// 	switch (notification.description.split(" ")[0].toLowerCase()) {
	// 		case "stock":
	// 			this.router.navigate(['/stock/' + notification.properties.stock]);
	// 			break;
	// 		case "invoice":
	// 			this.router.navigate(['/invoice/' + notification.properties.invoice]);
	// 			break;
	// 		case "jobsheet":
	// 			this.router.navigate(['/jobsheet/' + notification.properties.jobsheet]);
	// 			break;
	// 	}
	// }

	getNotificationClasses(notification: NotificationModel) {
		let classes: string[] = [];
		classes.push(notification.notification_type);
		return classes;
		//{'unread':!notification.read_at,notification.type};
	}

	// hasUnreadNotification() {
	// 	return this.notificationService.has_unread > 0;
	// }

	// getUnread() {
	// 	return this.notificationService.has_unread;
	// }

	// getHumanTime(date) {
	// 	//console.log(asset.gps.timestamp);
	// 	return moment.duration(moment(new Date()).diff(date)).humanize() + " ago";
	// }

	// filterMenu() {

	// 	let _this = this;
	// 	if (!this.authService.permissions) {
	// 		if (this.store.getItem('currentUser')) {
	// 			this.authService.permissions = this.store.getItem('currentUser')['permissions'];
	// 		}
	// 	}
	// 	if (this.authService.permissions) {
	// 		this.permissionsService.loadPermissions(this.authService.permissions);
	// 	}
	// 	let parentIdx = [];
	// 	for (let parent = 0; parent < this.menuLinks.length; parent++) {
	// 		if (!this.authService.hasPermission(this.menuLinks[parent].roles)) {
	// 			parentIdx.push(parent);
	// 		}
	// 		if (this.menuLinks[parent].submenu) {
	// 			let idxList = [];
	// 			for (let child = 0; child < this.menuLinks[parent].submenu.length; child++) {
	// 				if (this.menuLinks[parent].submenu[child]['roles'] && !this.authService.hasPermission(this.menuLinks[parent].submenu[child]['roles'])) {
	// 					idxList.push(child);
	// 					_this.menuLinks[parent].submenu.splice(child, 1);
	// 					child--;
	// 				}
	// 			}
		
	// 		}
	// 	}
	// 	parentIdx.forEach(index => {
	// 		delete this.menuLinks[index];
	// 	})
	// 	this.menuLinks = this.menuLinks.filter(Boolean);
	// }



	logout() {
		this.authService.signout();
	}


	isGraceMode() {
		if (!this.store.getItem('currentUser')) {
			return null;
		}
		return this.store.getItem('currentUser')['grace'];
	}

	isExpiredMode() {
		if (this.expiredModeHidden) {
			return null;
		}
		if (!this.store.getItem('currentUser')) {
			return null;
		}
		// if (this.store.getItem('currentUser')['company']['renewal']) {
		//   return this.store.getItem('currentUser')['company']['renewal']['expiry_date'];
		// }
		return null;
	}

	expiredModeHidden: boolean = false;
	hideExpiredMode() {
		this.expiredModeHidden = true;
		let updatedUser = this.store.getItem('currentUser');
		//updatedUser['company']['renewal'] = null;
		this.store.setItem('currentUser', updatedUser);
	}

	// isLoadingNotifications() {
	// 	return this.notificationService.notificationSub;
	// }

	// onScroll(element) {
	// 	let toBottom = element.target.scrollHeight - element.target.scrollTop === element.target.clientHeight;
	// 	if (toBottom) {
	// 		this.notificationService.loadNotifications(true);
	// 	}
	// }

	curruser
	getUsername() {
		if (!this.store.getItem('currentUser') ){
			return "Viewer";
		}
		this.curruser = this.store.getItem('currentUser')
		return this.curruser.first_name + ' ' + this.curruser.last_name;
	}

	getLogo() {
		return this.authService.getLogo();
	}

	getFavicon() {
		return this.authService.getFavicon();
	}

	isAuthenticated() {
		if (this.authService.initialTimeout || !this.authService.didFirstCheck) {
			return false;
		}
		return this.authService.authenticated;
	}

	// profile() {
	// 	this.router.navigate(['/profile']);
	// }

	// companyProfile() {
	// 	this.router.navigate(['/company/profile']);
	// }

	subscriptionModalTrigger: EventEmitter<any> = new EventEmitter<any>();
	openSubscriptionModal() {
		this.subscriptionModalTrigger.emit(true);
	}

	cardModalTrigger: EventEmitter<any> = new EventEmitter<any>();
	openCardModal() {
		this.cardModalTrigger.emit(true);
	}

	hasPermission(permission){
		if(this.authService.getUser().permissions.indexOf(permission) > -1)
		{
			return true;
		}
		return false;
	}

}
